
import { ICONS } from "../assets/registtyIcons/iconsRegistry";

export function resolveIcon(icon, iconVariant = "dark") {
  if (!icon) return null;

  // If icon is a registry key like "check"
  if (typeof icon === "string" && ICONS[icon]) {
    const entry = ICONS[icon];

    // entry is either "src" OR {dark, light}
    if (typeof entry === "string") return entry;

    return entry[iconVariant] || entry.dark || entry.light || null;
  }

  // Otherwise assume it's already a usable src string (imported image or public path)
  return icon;
}
